import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Space } from 'antd-mobile';
import {UserMenuPath} from "../enums/DeliveryNavigatePathEnum";

export default function Home() {
  const navigate = useNavigate();

  const goToScanner = () => {
    navigate('/scanner');
  };

  const goToDelivered = () => {
    navigate(UserMenuPath.USER_MENU_DELIVERED);
  };

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">首页</h1>
      <p className="mb-4">欢迎使用 Tita 移动端</p>
      
      <div className="mt-6">
        <Space direction="vertical" block>
          <Button color="primary" onClick={goToScanner} block>
            打开扫码功能
          </Button>
          <Button color="success" onClick={goToDelivered} block>
            派送完成流程
          </Button>
        </Space>
      </div>
    </div>
  );
} 